<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="blogLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="blogError" class="mc-error">{{ blogError }}</div>
      <div v-if="blogLoaded" class="mc-blog">
        <ul class="mc-blog__list">
          <router-link v-for="item in blog" :to="'/blog/'+item.id+'/'" tag="li" class="mc-blog__item mc-blog-card">
            <div class="mc-blog-card__title">
              {{ item.name }}
            </div>
            <picture class="mc-blog-card__picture">
              <img class="mc-blog-card__image" :src="item.image" width="330" height="216" alt="">
            </picture>
            <div class="mc-blog-card__date">
              {{ item.date }}
            </div>
          </router-link>
        </ul>
        <button v-if="!loadingMore" @click="loadMoreBlog" class="mc-blog__button-more mc-button simulated-hover" type="button">
                        <span class="mc-button__text">
                            Показать еще
                        </span>
        </button>
        <div v-if="loadingMore" class="mc-loader"><span class="mc-loader__circle"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data: () => ({
    loadingMore: false,
    currentPage: 1,
  }),
  mounted() {

  },
  created() {
    this.fetchBlog({page:this.currentPage});
  },
  computed: {
    ...mapGetters([
      'blog',
      'blogLoading',
      'blogError',
      'blogLoaded',
      'noMoreBlog',
    ]),
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchBlog'
    ]),
    async loadMoreBlog() {
      // Set loading state
      if (this.loadingMore)
        return;
      this.loadingMore = true;

      // Get current page from store or local state
      const nextPage = this.currentPage + 1;
      await this.fetchBlog({ page:nextPage});
      this.loadingMore = false;
      this.currentPage++;
    },
  },
}
</script>

